import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: { main: "#254f46", light: "#e7eee6", dark: "#183d35" },
    secondary: { main: "#af643c" },
    background: { default: "#f6f3eb", paper: "#fffdf8" },
    text: { primary: "#263b34", secondary: "#67736a" },
    divider: "#e3e4d7",
  },
  typography: {
    fontFamily: "'Segoe UI', Arial, sans-serif",
    h1: {
      fontFamily: "Georgia, serif",
      fontWeight: 500,
      fontSize: "clamp(2.8rem, 6vw, 5.3rem)",
      letterSpacing: "-0.055em",
      lineHeight: 1.07,
    },
    h2: {
      fontFamily: "Georgia, serif",
      fontWeight: 500,
      fontSize: "clamp(2rem, 4vw, 3.2rem)",
      letterSpacing: "-0.035em",
    },
    h3: { fontFamily: "Georgia, serif", fontWeight: 500 },
    h4: { fontFamily: "Georgia, serif", fontWeight: 500, fontSize: "2.3rem" },
    h5: { fontFamily: "Georgia, serif", fontWeight: 500, fontSize: "1.7rem" },
    h6: { fontFamily: "Georgia, serif", fontWeight: 500, fontSize: "1.35rem" },
    button: { textTransform: "none", fontWeight: 600, letterSpacing: 0 },
    body1: { lineHeight: 1.75 },
    overline: { letterSpacing: ".16em", fontWeight: 700 },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { padding: "10px 20px", borderRadius: 8 },
        outlined: { borderColor: "#bdcbbd" },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: "none" },
        elevation6: {
          boxShadow: "0 16px 60px #263b3410",
          border: "1px solid #e3e4d7",
        },
      },
    },
    MuiCard: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: {
          border: "1px solid #e3e4d7",
          boxShadow: "0 4px 18px #263b3405",
        },
      },
    },
    MuiTextField: { defaultProps: { variant: "outlined" } },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { backgroundColor: "#fffefa" },
        input: { fontSize: 16 },
      },
    },
    MuiContainer: { styleOverrides: { root: { position: "relative" } } },
  },
});
export default theme;
